export const MENU_STATUS = {
  COLLAPSED: 'collapsed',
  EXPANDED: 'expanded',
};
export const minWidth = 80;
export const maxWidth = 150;
